'use client'
import { TranslationProvider } from '@/Utils/Hooks/useTranslate';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const TanstackWrapper = ({ children }: { children: React.ReactNode }) => {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 0,
            },
        },
    });
    return (
        <QueryClientProvider client={queryClient}>
            <TranslationProvider>
                {children}
            </TranslationProvider>
        </QueryClientProvider>
    )
}

export default TanstackWrapper
